package team.platforma.chat_data.network.body

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateChatBody(
   @SerialName("title") val title: String,
   @SerialName("ai_model_id") val aiModelId: Long
)
